module.exports = __webpack_public_path__ + "img/14.dfc68f4.dfc68f40.png";